import React, { useMemo, useState } from "react";
import AFilterForm from "../../.../../../../../components/AFilterForm/AFilterForm";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import FilterCountBadge from "../../components/FilterCountBadge";
import { getAppliedFilterCount } from "../../receipt/hooks/useFilterCount";

const btnStyle = {
  fontFamily: "Gilroy-Bold",
  color: "black",
};
const activeBtn = {
  fontFamily: "Gilroy-Bold",
  color: "#00B0F5",
};

const statusOptions = [
  { label: "L1 Pending", value: "L1_PENDING" },
  { label: "L2 Pending", value: "L2_PENDING" },
  { label: "L3 Pending", value: "L3_PENDING" },

  { label: "Deposited", value: "DEPOSITED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "L1 Sent for Correction", value: "L1_SENT_CORRECTION" },
  { label: "L2 Sent for Correction", value: "L2_SENT_CORRECTION" },
  { label: "L3 Sent for Correction", value: "L3_SENT_CORRECTION" },
];

const DepositedSlipFilterDrawer = ({
  applyFilterHandler,
  onRemoveFilterHandler,
  dropdownValues,
  appliedForm = {},
}) => {
  const [filterForm, setFilterForm] = useState({});

  const handleFilterForm = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };


  const removeFilterHandler = () => {
    onRemoveFilterHandler();
    setFilterForm({});
  };

  const formConfig = useMemo(() => {
    return [
     
      {
        label: "Status",
        type: "select",
        formKey: "status",
        items: statusOptions,
        placeholder: "Select",
        colSpan: 2,
        isMulti: true,
        isShowCount: true,
      },

      {
        label: "Deposited Date from",
        type: "date",
        formKey: "startDate",
        placeholder: "Select Date",
        colSpan: 2,
        maxDate: filterForm?.endDate,
      },
      {
        label: "Deposited Date to",
        type: "date",
        formKey: "endDate",
        placeholder: "Select Date",
        colSpan: 2,
        minDate: filterForm?.startDate,
      },
    ];
  }, [dropdownValues,filterForm]);

  const appliedFilterCount = useMemo(
    () => getAppliedFilterCount(appliedForm, formConfig),
    [appliedForm, formConfig]
  );

  return (
    <AFilterForm
      btnComponent={
        <div>
          <AButton
            updatedStyle={appliedFilterCount > 0 ? activeBtn : btnStyle}
            variant={appliedFilterCount > 0 ? "outline" : "general"}
            size="xs"
            className="no-ml-btn"
          >
            Filters
          </AButton>
          <FilterCountBadge count={appliedFilterCount} />
        </div>
      }
      formFields={formConfig}
      filterForm={filterForm}
      handleFilterForm={handleFilterForm}
      applyFilterHandler={applyFilterHandler}
      removeFilterHandler={removeFilterHandler}
    />
  );
};

export default DepositedSlipFilterDrawer;
